/**
 * <PageLoadingShell /> — centred logo + "Loading…" splash.
 *
 * Lives in its own file so `App.tsx` can use it as a `<Suspense>`
 * fallback without eager-importing the lazy `/qr/new` chunk. If we
 * imported the same shell from `routes/QrQuickCreate.tsx` we'd pull
 * `@d-m-organization/qr-ui` (and its `qr-code-styling` peer) into the
 * eager Hub bundle, defeating the whole lazy-load goal of HD-97 M4.
 *
 * Token palette matches Dashboard.tsx.
 */

import React from "react";
import { LogoMark } from "./LogoMark.js";

const T = {
  bg: "#f0eef6",
  textMuted: "#6b7084",
  purple: "#351DBD",
} as const;

export function PageLoadingShell() {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: T.bg,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div style={{ textAlign: "center" }}>
        <LogoMark color={T.purple} size={40} />
        <p style={{ fontSize: 14, color: T.textMuted, marginTop: 16 }}>
          Loading…
        </p>
      </div>
    </div>
  );
}
